import type { SVGProps } from "react";

const SvgJuniSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="46.0 46.0 420.0 420.0"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="#FF3C19"
      d="M46 46h420v420H46zm130.958 100.625c-.004 15.816 0 31.628 0 47.444 43.781.004 87.563-.003 131.344.004.007 30.236-.004 60.476.007 90.713-.07.941.242 2.03-.423 2.819-8 11.951-15.995 23.905-24.014 35.84-15.622 5.53-31.213 11.13-46.826 16.676-15.634-5.546-31.259-11.13-46.881-16.711a57222 57222 0 0 0-32.021-48.036 22941 22941 0 0 0-41.572 25.162c13.685 20.887 27.424 41.739 41.121 62.618 26.456 9.579 52.9 19.188 79.364 28.751 19.293-7.012 38.601-13.984 57.898-20.992 7.132-2.641 14.358-5.079 21.428-7.852 13.595-20.522 27.031-41.156 40.596-61.697.268-.443.591-.895.525-1.435-.012-51.1.004-102.204-.008-153.304-60.177 0-120.357-.004-180.538 0"
    />
    <path
      fill="#fff"
      d="M176.959 146.625c60.18-.004 120.361 0 180.538 0 .011 51.1-.004 102.204.008 153.304.066.54-.257.991-.526 1.435-13.564 20.541-27 41.175-40.596 61.697-7.07 2.773-14.295 5.211-21.427 7.852-19.297 7.007-38.605 13.98-57.898 20.992-26.464-9.563-52.909-19.172-79.365-28.751-13.696-20.879-27.436-41.731-41.121-62.619a24279 24279 0 0 1 41.572-25.161 58052 58052 0 0 1 32.022 48.036c15.621 5.58 31.247 11.165 46.88 16.71 15.614-5.545 31.205-11.145 46.826-16.675 8.019-11.935 16.015-23.89 24.014-35.84.665-.79.354-1.879.424-2.82-.012-30.236 0-60.476-.008-90.712-43.781-.008-87.562 0-131.343-.004 0-15.816-.004-31.628 0-47.444"
    />
  </svg>
);
export default SvgJuniSmallLogo;
